<template>
  <page class="home-page">
    <zui-header>
      <logo type="xiaoyanyun" href="/"></logo>
      <h4 class="zui-logo-text">
        |&nbsp;&nbsp;国潮国色 让爱美丽
        <br/>|&nbsp;&nbsp;让家健康 让社会更美好
      </h4>
      <el-dropdown class="zui-rightcol" @command="handleCommand" trigger="click">
        <span class="el-dropdown-link">
          网站导航<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <template v-for="(zbtn,zi) in headBtn">
            <el-dropdown-item :command="zbtn.key" :key="zi">{{zbtn.text}}</el-dropdown-item>
          </template>
          </el-dropdown-menu>
        </el-dropdown>
      <template v-for="(zbtn,zi) in headBtn">
        <zui-button @click="onButtonClick(zbtn.key)" :key="zi" :class="activeFlag(zbtn.key)?'active':''">{{zbtn.text}}</zui-button>
      </template>
    </zui-header>
      <div id="wrapper" class="pcWrapper">
        <!--focus start-->
        <div id="FocusBG" class="pcFocusBG joinFocusBG">
          <img src="../assets/img/product/v3/pn_bg.jpg" class="inside_top_bg">
        </div>


        <!--focus end-->
        <!--body start-->
        <div id="body">
          <!--inner start -->
          <div class="inner join">
            <!--right start-->
            <div class="right">
              <div class="PosLeft">产品中心</div>
              <!--main start-->
              <div class="main">

                <!--content start-->
                <div class="content">
                  <div class="MorePro">
                    <div class="CaseBlock">
                      <ul>

                        <div class="albumblock">
                          <a href="/Product/168309580.html" target="_blank" title="珂立诺艺术涂料" class="Pic">
                            <img src="../assets/img/product/v3/202346113538.jpg" alt="珂立诺艺术涂料">
                          </a>
                          <div class="intro">
                            <a href="/Product/168309580.html" target="_blank" title="珂立诺艺术涂料">
                              <h3>珂立诺艺术涂料</h3>
                              <p>珂立诺艺术涂料因为是通过高温烧制的，瓷制砂内部疏松而吸收更多的乳液混合物形成，表面紧密,使其具有超强硬度、强抗刮擦力、柔... </p>
                            </a>
                          </div>
                        </div>
                        <div class="albumblock">
                          <a href="/Product/8346295739.html" target="_blank" title="升级版天鹅绒/经典天鹅绒" class="Pic">
                            <img src="../assets/img/product/v3/202210251689.jpg" alt="升级版天鹅绒/经典天鹅绒">
                          </a>
                          <div class="intro">
                            <a href="/Product/8346295739.html" target="_blank" title="升级版天鹅绒/经典天鹅绒">
                              <h3>升级版天鹅绒/经典天鹅绒</h3>
                              <p>珠光幻影的视觉体验，如丝绸般顺滑的手感，平面亦可带来强烈的层叠效果，彰显奢华迷人的风情。 ... </p>
                            </a>
                          </div>
                        </div>
                        <div class="albumblock">
                          <a href="/Product/568721567.html" target="_blank" title="蛋壳光" class="Pic">
                            <img src="../assets/img/product/v3/2022820175553.jpg" alt="蛋壳光"></a>
                          <div class="intro">
                            <a href="/Product/568721567.html" target="_blank" title="蛋壳光">
                              <h3>蛋壳光</h3>
                              <p>取之于大自然，水滴溅入湖面，击起的层层涟漪。散发着淡淡的蛋壳柔光光泽，自然与斑驳的肌理相融合，营造出低调又奢华的居家氛围... </p>
                            </a>
                          </div>
                        </div>

                        <div class="albumblock">
                          <a href="/Product/168309580.html" target="_blank" title="珂立诺艺术涂料" class="Pic">
                            <img src="../assets/img/product/v3/202346113538.jpg" alt="珂立诺艺术涂料">
                          </a>
                          <div class="intro">
                            <a href="/Product/168309580.html" target="_blank" title="珂立诺艺术涂料">
                              <h3>珂立诺艺术涂料</h3>
                              <p>珂立诺艺术涂料因为是通过高温烧制的，瓷制砂内部疏松而吸收更多的乳液混合物形成，表面紧密,使其具有超强硬度、强抗刮擦力、柔... </p>
                            </a>
                          </div>
                        </div>
                        <div class="albumblock">
                          <a href="/Product/8346295739.html" target="_blank" title="升级版天鹅绒/经典天鹅绒" class="Pic">
                            <img src="../assets/img/product/v3/202210251689.jpg" alt="升级版天鹅绒/经典天鹅绒">
                          </a>
                          <div class="intro">
                            <a href="/Product/8346295739.html" target="_blank" title="升级版天鹅绒/经典天鹅绒">
                              <h3>升级版天鹅绒/经典天鹅绒</h3>
                              <p>珠光幻影的视觉体验，如丝绸般顺滑的手感，平面亦可带来强烈的层叠效果，彰显奢华迷人的风情。 ... </p>
                            </a>
                          </div>
                        </div>
                        <div class="albumblock">
                          <a href="/Product/568721567.html" target="_blank" title="蛋壳光" class="Pic">
                            <img src="../assets/img/product/v3/2022820175553.jpg" alt="蛋壳光"></a>
                          <div class="intro">
                            <a href="/Product/568721567.html" target="_blank" title="蛋壳光">
                              <h3>蛋壳光</h3>
                              <p>取之于大自然，水滴溅入湖面，击起的层层涟漪。散发着淡淡的蛋壳柔光光泽，自然与斑驳的肌理相融合，营造出低调又奢华的居家氛围... </p>
                            </a>
                          </div>
                        </div>

                        <div class="albumblock">
                          <a href="/Product/168309580.html" target="_blank" title="珂立诺艺术涂料" class="Pic">
                            <img src="../assets/img/product/v3/202346113538.jpg" alt="珂立诺艺术涂料">
                          </a>
                          <div class="intro">
                            <a href="/Product/168309580.html" target="_blank" title="珂立诺艺术涂料">
                              <h3>珂立诺艺术涂料</h3>
                              <p>珂立诺艺术涂料因为是通过高温烧制的，瓷制砂内部疏松而吸收更多的乳液混合物形成，表面紧密,使其具有超强硬度、强抗刮擦力、柔... </p>
                            </a>
                          </div>
                        </div>
                        <div class="albumblock">
                          <a href="/Product/8346295739.html" target="_blank" title="升级版天鹅绒/经典天鹅绒" class="Pic">
                            <img src="../assets/img/product/v3/202210251689.jpg" alt="升级版天鹅绒/经典天鹅绒">
                          </a>
                          <div class="intro">
                            <a href="/Product/8346295739.html" target="_blank" title="升级版天鹅绒/经典天鹅绒">
                              <h3>升级版天鹅绒/经典天鹅绒</h3>
                              <p>珠光幻影的视觉体验，如丝绸般顺滑的手感，平面亦可带来强烈的层叠效果，彰显奢华迷人的风情。 ... </p>
                            </a>
                          </div>
                        </div>
                        <div class="albumblock">
                          <a href="/Product/568721567.html" target="_blank" title="蛋壳光" class="Pic">
                            <img src="../assets/img/product/v3/2022820175553.jpg" alt="蛋壳光"></a>
                          <div class="intro">
                            <a href="/Product/568721567.html" target="_blank" title="蛋壳光">
                              <h3>蛋壳光</h3>
                              <p>取之于大自然，水滴溅入湖面，击起的层层涟漪。散发着淡淡的蛋壳柔光光泽，自然与斑驳的肌理相融合，营造出低调又奢华的居家氛围... </p>
                            </a>
                          </div>
                        </div>

                      </ul>
                    </div>
                    <div class="clearfix"></div>
                    <div class="t_page ColorLink">总数：19条&nbsp;&nbsp;当前页数：<span class="FontRed">1</span>/2<a href="index.html">首页</a>&nbsp;&nbsp;上一页&nbsp;&nbsp;<a href="index.html">1</a> <a href="list_2.html">2</a> <a href="list_2.html">下一页</a><a href="list_2.html">尾页</a></div>
                  </div>

                </div>
                <!--content end-->

              </div>
              <!--main end-->
            </div>
            <!--right end-->
            <div class="clearfix"></div>
          </div>
          <!--inner end-->
        </div>
        <!--body end-->
        <div class="HeightTab clearfix"></div>

      </div>

    <div id="wrapper">
      <!--focus start-->
      <div id="FocusBG">
        <img src="../assets/img/product/mpn_bg.jpg" class="inside_top_bg">

        <div class="inside_top">
          <div class="container">
            <div class="in_title">
              <h2>产品中心</h2>
              <h1>Product</h1>
              <div class="ico"></div>
            </div>
            <ul class="submeau"></ul>
          </div>
        </div>

      </div>


      <!--focus end-->
      <!--body start-->
      <div id="body">
        <!--inner start -->
        <div class="inner">
          <!--right start-->
          <div class="right">
            <div class="Position"><span>你的位置：<a href="/">首页</a> &gt; <a href="/M/Product/">产品中心</a></span></div>
            <div class="HeightTab clearfix"></div>
            <!--main start-->
            <div class="main">

              <!--content start-->
              <div class="content">
                <div class="MorePro">
                  <div class="CaseBlock">
                    <ul>
                      <ul>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/6973082245.html" target="_blank" title="曼哈顿">
                              <img src="../assets/img/product/2022820171947.jpg" alt="曼哈顿"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/6973082245.html" target="_blank" title="曼哈顿">曼哈顿</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/0653482146.html" target="_blank" title="微水泥">
                              <img src="../assets/img/product/2022820171947.jpg" alt="微水泥"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/0653482146.html" target="_blank" title="微水泥">微水泥</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/4965812017.html" target="_blank" title="雅晶石">
                              <img src="../assets/img/product/2022820171947.jpg" alt="雅晶石">
                            </a>
                            <div class="albumtitle">
                              <a href="/M/Product/4965812017.html" target="_blank" title="雅晶石">雅晶石</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/5826301823.html" target="_blank" title="陶晶彩">
                              <img src="../assets/img/product/2022820171947.jpg" alt="陶晶彩"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/5826301823.html" target="_blank" title="陶晶彩">陶晶彩</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/6973082245.html" target="_blank" title="曼哈顿">
                              <img src="../assets/img/product/2022820171947.jpg" alt="曼哈顿"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/6973082245.html" target="_blank" title="曼哈顿">曼哈顿</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/0653482146.html" target="_blank" title="微水泥">
                              <img src="../assets/img/product/2022820171947.jpg" alt="微水泥"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/0653482146.html" target="_blank" title="微水泥">微水泥</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/4965812017.html" target="_blank" title="雅晶石">
                              <img src="../assets/img/product/2022820171947.jpg" alt="雅晶石">
                            </a>
                            <div class="albumtitle">
                              <a href="/M/Product/4965812017.html" target="_blank" title="雅晶石">雅晶石</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/5826301823.html" target="_blank" title="陶晶彩">
                              <img src="../assets/img/product/2022820171947.jpg" alt="陶晶彩"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/5826301823.html" target="_blank" title="陶晶彩">陶晶彩</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/6973082245.html" target="_blank" title="曼哈顿">
                              <img src="../assets/img/product/2022820171947.jpg" alt="曼哈顿"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/6973082245.html" target="_blank" title="曼哈顿">曼哈顿</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/0653482146.html" target="_blank" title="微水泥">
                              <img src="../assets/img/product/2022820171947.jpg" alt="微水泥"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/0653482146.html" target="_blank" title="微水泥">微水泥</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/4965812017.html" target="_blank" title="雅晶石">
                              <img src="../assets/img/product/2022820171947.jpg" alt="雅晶石">
                            </a>
                            <div class="albumtitle">
                              <a href="/M/Product/4965812017.html" target="_blank" title="雅晶石">雅晶石</a>
                            </div>
                          </div>
                        </div>
                        <div class="albumblock">
                          <div class="inner">
                            <a href="/M/Product/5826301823.html" target="_blank" title="陶晶彩">
                              <img src="../assets/img/product/2022820171947.jpg" alt="陶晶彩"></a>
                            <div class="albumtitle">
                              <a href="/M/Product/5826301823.html" target="_blank" title="陶晶彩">陶晶彩</a>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </ul>
                  </div>
                  <div class="clearfix"></div>
                  <div class="t_page ColorLink">总数：19条&nbsp;&nbsp;当前页数：<span class="FontRed">2</span>/2<a href="index.html">首页</a><a href="index.html">上一页</a><a href="list_2.html"><span class="FontRed">2</span></a> &nbsp;&nbsp;下一页&nbsp;&nbsp;<a href="list_2.html">尾页</a></div>
                </div>

              </div>
              <!--content end-->

            </div>
            <!--main end-->
          </div>
          <!--right end-->
        </div>
        <!--inner end-->
      </div>
      <!--body end-->
      <div class="clearfix"></div>
    </div>


    <zui-footer/>
  </page>
</template>
<script>
  import '../assets/css/quanping.css'
  import '../assets/css/product.css'
  import '../assets/css/Minner.css'
  import '../assets/less/home-page.less'
  import Logo from '../components/portal/Logo'
  import Page from '../components/portal/Page'
  import ZuiHeader from '../components/portal/Header'
  import ZuiFooter from '../components/portal/Footer'
  import ZuiButton from '../components/portal/Button'
  import Util from '../Util'
  export default{
    components: {
      Page, Logo, ZuiHeader, ZuiFooter,ZuiButton
    },
    data () {
      return {
        carouselPerPage: (Util.os.android || Util.os.iPhone) ? 1 : 2
      }
    },
    methods: {

    }
  }
</script>
<style>
  .c1{
    width: 80%;
    margin: 0 auto;
  }

  .clearfix {
    clear: both;
  }
  .pcWrapper  .t_page{
    padding:10px;
    text-align:center;
    font-size:12px;
    line-height:25px;

  }
  .pcWrapper  .t_page a{
    padding:2px 5px;
    border:1px solid #DEDEDC;
    margin:0px 3px;
  }
  .albumblock {
    padding: 10px 10px 15px 10px;
    float: left;
  }
</style>
